// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8315) return "static/chunks/8315-1be63b619e5114ca.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"912":"d4f2f28ae4c9bf02","1196":"10463a103188f540","1283":"92131bfeb9cfacd6","1498":"f3cec287a1ddf52f","4971":"7a76df50fe110558","5458":"0c4ccdd2636f5299","7445":"fdd04c58ab48920e","9721":"b357aa2c1e2ee8ef","9826":"b8a83d31e1d05a2a"}[chunkId] + ".js";
};